import "../../../libs/backbone/backbone.ajaxq.adapter.ts";
import GenericView from '../generic.view.ts';

import Handlebars from 'handlebars';
import Template from 'text-loader!../../templates/issueTicket/queueRow.template.html';

import Model from '../../models/issueTicket/queueRow.model.ts';

import i18n  from "l10n";

import PopupView from "../helpers/popup.view.ts";

export default Backbone.View.extend({
    tagName: 'div',
    className: 'content mt-3 col-12 col-sm-6',
	template: Handlebars.compile(Template),
	ticketInfoPartialTemplate: Handlebars.compile("{{> ticketInfoPartialTemplate this}}"),
    model: null,
    initialize: function (options) {
        var self = this;

        if(options && options.model) {
            this.model = new Model(options.model);
        }
        else {
            this.model = new Model();

            this.model.set("id", -1);
            this.model.set("name", "-");
            this.model.set("englishName", "-");
            this.model.set("currentTicketNumber", "-");
            this.model.set("status", "Closed");
            this.model.set("flowStatus", "Normal");
            this.model.set("openNow", false);

        }

        this.printerView = options ? options.printerView : null;

        this.render();

	},
	superRender: Backbone.View.prototype.render,
	render: function () {
		this.superRender();

        var templateData = this.template( this.model.toJSON() );
		this.$el.html( templateData );

        return this;
	},
	events:{
         "click #issueTicket": "issueTicketOnQueue"
	},
	setupAjax: function() {
        var self = this;

        $.ajaxSetup({
            beforeSend: function (xhr) {
                var lang = i18n.lng() == "en" ? "en-GB" : "el-GR";

                xhr.setRequestHeader('X-CSRF-TOKEN', window.csrf);
                xhr.setRequestHeader('X-Client-Type', self.clientType);
                xhr.setRequestHeader('X-Client-Auth', self.clientAuth);
                xhr.setRequestHeader('Accept-Language', lang);

            },
            error: function (xhr, exception) {

            }
        });
    },
	issueTicketOnQueue: function(e) {
        var self = this;

        var $elem = $(e.currentTarget);

        if(!$elem.hasClass("disabled"))
            $elem.addClass("disabled");

        if(this.model.get("status") == "Closed") {
            var notifyInfo = Handlebars.helpers.getNotifyConfigForTicketIssueStatus("FailClosedQueue")

            $elem.notify(notifyInfo.text, notifyInfo.config);
            return;
        }

        $.when(window.ping()).then(function(resp) {
            self.setupAjax();

            $.ajaxDefaultQ({
                url: "rest/api/adminTickets/" + self.model.get('id'),
                type: 'POST',
                beforeSend: function (xhr) {
                    xhr.setRequestHeader('X-CSRF-TOKEN', window.csrf);
                }
            }).done(function(response, status, xhr){

                if(response && response.data) {
                    var notifyInfo = Handlebars.helpers.getNotifyConfigForTicketIssueStatus(response.data.status)

                    $elem.notify(notifyInfo.text, notifyInfo.config);

                    if(response.data.status && response.data.status == "Success") {

                        var options = {
                            "popupOptions": {

                            },
                            "popupTypeOptions": {
                                "type": "info",
                                "title": notifyInfo.text,
                                "content": self.ticketInfoPartialTemplate( response.data.issuedTicket )
                            }
                        };
                        var popupView = new PopupView(options);

                        if(!self.printerView) {
                            $.notify(i18n.t("settings.printer.noPrinterConfigured"), { position:"top center", className: "info"});
                            return;
                        }

                        var printerData = {
                            "queueData": self.model.toJSON(),
                            "ticketData": response.data.issuedTicket
                        };

                        self.printerView.sendDataToPrint(printerData);
                    }
                }

                $elem.removeClass("disabled");

            })
            .fail(function(response) {
                $elem.notify(i18n.t("server.error"), { position:"top center", className: "error"});

                $elem.removeClass("disabled");
            })
        });
	}

});


